import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { NewIpDevice } from '../../../types'

export const deviceCreate = async (payload: { body: NewIpDevice; type: string }) => {
  const { body, type } = payload
  const response = await axios.post(`${getAPIService}/v2/api/ip-devices/${type}`, body)
  return response.data
}
